import AnalyticsIcon from "../../assets/images/icons/sideMenu/analyticsIcon";
import ArrowUpDownIcon from "../../assets/images/icons/sideMenu/arrowUpDownIcon";
import BuildingsIcon from "../../assets/images/icons/sideMenu/buildingsIcon";
import DashboardIcon from "../../assets/images/icons/sideMenu/dashboardIcon";
import FreeAdvertisementIcon from "../../assets/images/icons/sideMenu/freeAdvertisementIcon";
import HomeIcon from "../../assets/images/icons/sideMenu/homeIcon";
import ImageIcon from "../../assets/images/icons/sideMenu/imageIcon";
import InfoIcon from "../../assets/images/icons/sideMenu/infoIcon";
import ListIcon from "../../assets/images/icons/sideMenu/listIcon";
import MailIcon from "../../assets/images/icons/sideMenu/mailIcon";
import MoveUpIcon from "../../assets/images/icons/sideMenu/moveUpIcon";
import QrCodeIcon from "../../assets/images/icons/sideMenu/qrCodeIcon";
import UserCardIcon from "../../assets/images/icons/sideMenu/userCardIcon";
import UserCheckIcon from "../../assets/images/icons/sideMenu/userCheckIcon";

export const getMenuIcon = (icon) => {
	switch (icon) {
		case 'ListIcon':
			return () => <ListIcon/>
		case 'InfoIcon':
			return () => <InfoIcon/>
		case 'DashboardOutlined':
			return () => <DashboardIcon/>
		case 'MailIcon':
			return () => <MailIcon/>
		case 'ImageIcon':
			return () => <ImageIcon/>
		case 'UserCardIcon':
			return () => <UserCardIcon/>
		case 'HomeIcon':
			return () => <HomeIcon/>
		case 'MoveUp':
			return () => <MoveUpIcon/>
		case 'SettingsApplications':
			return () => <BuildingsIcon/>
		case 'ImportExport':
			return () => <ArrowUpDownIcon/>
		case 'Analytics':
			return () => <AnalyticsIcon/>
		case 'UserCheckIcon':
			return () => <UserCheckIcon/>
		case 'QrCodeIcon':
			return () => <QrCodeIcon/>
		case 'FreeAdvertisementIcon':
			return () => <FreeAdvertisementIcon/>
		default:
			return
	}
}